import React, {useEffect} from 'react';
import {
    Col,
    Row
} from 'reactstrap';

import TypeAudienceList from "./_list";
import TypeAudienceForm from "./_form";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import {clearState, setApp, setCategory, setUdn, setViewMode, setLoading} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {connect} from "react-redux";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

const TypeAudience = (props) => {
    const { loading } = props.mainProps

    // Modo de vista: LIST, FORM

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const newItem = () => {
        props.setForm(null)
        ModalFormContainer(TypeAudienceForm, { data: null, Form: TypeAudienceForm });
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={newItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <TypeAudienceList />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(TypeAudience)